// Used to prevent circle dependency.

// eslint-disable-next-line import/prefer-default-export
export const titleSearchBarHeight = '15rem';
